import type {BuildId} from '../../../../types'
import {stringifyId} from '../../../../types'

export const getDependantsLocator = (buildId: BuildId): string =>
  `defaultFilter:false,snapshotDependency(from:(id:${stringifyId(
    buildId,
  )})),count:1000,lookupLimit:50000`
